import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useGlobalStyles } from 'GlobalStyles';
import strings from 'strings';

const SHARED_BUTTON_PROPS = {
  color: 'primary',
  size: 'large',
  variant: 'text'
};

export const HeaderButtons = ({ onResetForm }) => {
  const classes = useGlobalStyles();

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button {...SHARED_BUTTON_PROPS} className={classes.noTransform} onClick={onResetForm}>
        {strings.formatString(strings.shared.ui.reset, { item: strings.shared.ui.form })}
      </Button>
    </Box>
  );
};
